module.exports = __webpack_public_path__ + "media/images/emblems/Schelten-coat_of_arms-22b9fa1f104549b890e666038f55c3e4.svg";